<template>
  <Authenticate>
    <forgot-change-password />
  </Authenticate>
</template>

<script>
import Authenticate from "@/components/authenticate/Authenticate";
import ForgotChangePassword from "@/components/authenticate/ForgotChangePassword.vue";

export default {
  components: {
    Authenticate,
    ForgotChangePassword
  }
};
</script>
